module.exports = __webpack_public_path__ + "static/mockup-25b98ed1ffbac300e7164ba7c4137268.png";